import { useState, useEffect } from 'react'

export interface CurrencyInfo {
  symbol: string
  rate: number
  code: string
}

export function useCurrencyDetection() {
  const [currency, setCurrency] = useState<CurrencyInfo>({
    symbol: '$',
    rate: 1,
    code: 'ARS',
  })

  useEffect(() => {
    try {
      const locale = navigator.language || 'es-AR'

      // Basic conversion rates for demonstration purposes based on 19,990 ARS base
      if (locale.startsWith('en-US') || locale === 'en') {
        setCurrency({ symbol: 'U$D', rate: 0.001, code: 'USD' }) // ~20 USD
      } else if (
        locale.startsWith('es-ES') ||
        locale.startsWith('eu') ||
        locale.startsWith('ca')
      ) {
        setCurrency({ symbol: '€', rate: 0.00092, code: 'EUR' }) // ~18.5 EUR
      } else if (locale.startsWith('en-GB')) {
        setCurrency({ symbol: '£', rate: 0.00079, code: 'GBP' }) // ~15.8 GBP
      } else if (locale.startsWith('pt-BR')) {
        setCurrency({ symbol: 'R$', rate: 0.005, code: 'BRL' }) // ~100 BRL
      } else {
        setCurrency({ symbol: '$', rate: 1, code: 'ARS' })
      }
    } catch (e) {
      // Fallback to ARS if navigator is not available
      setCurrency({ symbol: '$', rate: 1, code: 'ARS' })
    }
  }, [])

  return currency
}
